import { Injectable } from '@angular/core';
import { catchError, map } from "rxjs/operators";
import { GenericHttpService } from "../../../../../shared/services/generic-http.service";
import { environment } from "../../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class InventoryHighlightService {

  constructor(private generic: GenericHttpService) { }

  Allvalues;
  apiUrl = environment.gateWayHost;
  
  individualInventory(url) {
    const option = {
      method: "GET",
      url: `${this.apiUrl}${url}`
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData)
    );
  }
}
